import { Box, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useTranslation } from "react-i18next";

export interface AuthWrapperProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

// Want a reusable wrapper that mimics Amplify's Authenticator look.
export const AuthWrapper = ({
  title,
  subtitle,
  children
}: AuthWrapperProps) => {
  const { t } = useTranslation();
  return (
    <Grid
      alignItems={"center"}
      xs={12}
      flexDirection={"column"}
      display={"flex"}
    >
      <Box sx={{ padding: "24px", textAlign: "center" }}>
        <img src={process.env.PUBLIC_URL + "/simpl_logo_wide.png"} alt="logo" />
      </Box>
      <Paper
        sx={{
          paddingLeft: 2,
          paddingRight: 2,
          maxWidth: "480px",
          width: "100%"
        }}
      >
        <Grid
          sx={{ padding: "32px" }}
          spacing={2}
          container
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Grid xs={12}>
            <Typography
              fontSize={"32px"}
              fontWeight={"700"}
              textAlign={"center"}
            >
              {t(title)}
            </Typography>
          </Grid>
          {subtitle && (
            <Grid>
              <Typography>{subtitle}</Typography>
            </Grid>
          )}
          {children}
        </Grid>
      </Paper>
    </Grid>
  );
};
